export { useLottieData } from './useLottieData';
